module.exports = __webpack_public_path__ + "img/folder.28e9c9bf.svg";